/* istanbul ignore file */
import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import type { Data } from 'framework/types';
import ShowData from './ShowData';
import { ShowDataInstance } from './ShowTypes';

interface ShowContextData {
  data: Data;
  setData?: Dispatch<SetStateAction<ShowDataInstance>>;
}

const ShowContext = createContext<ShowContextData>({
  data: new ShowData({}),
  setData: () => null,
});
const ShowContextProvider = ShowContext.Provider;

const useShowContext = <T = Data<any>>() => {
  const context = useContext(ShowContext);
  return {
    ...context,
    data: context.data as Data<T>,
    setData: context.setData as Dispatch<SetStateAction<any>> | undefined,
  };
};
export { useShowContext, ShowContextProvider };
